import BaseService from '../../base/base_service';
import { SYSTEM_EVENTS } from '../../events/events';
import { TrackJS } from "trackjs";

interface ITrackJsParams {
    enabled: boolean;
    application: string;
    token: string;
}

class TrackjsService extends BaseService {

    static CLASS = 'TrackjsService';

    private _application: string;
    private _token: string;
    private _userCID: string;
    private _version: string;

    init(params: ITrackJsParams) {
        super.init(params);

        this._application = params.application;
        this._token = params.token;

        if(params.enabled) {
            this.onSystemEvent(SYSTEM_EVENTS.ON_INIT_COMPLETE, () => {
                this._initTrackJS();
            });
        }
    }

    private _initTrackJsExtraInformation(): void {
        this._userCID = this._getUserCID();
        this._version = this.serviceFactory.skinService().getVersion();

        this.onSystemEvent(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, () => {
           this._userCID = this._getUserCID();

           TrackJS.removeMetadata("CID");
           TrackJS.addMetadata("CID", this._userCID);
        });
    }

    private _initTrackJS(): void {
        this._initTrackJsExtraInformation();

        TrackJS.install({
            token: this._token,
            version: this._version,
            application: this._application
        });

        TrackJS.addMetadata("CID", this._userCID);
    }

    private _getUserCID(): string {
        if (this.serviceFactory.oAuth2Service().isAuthorized())
            return this.serviceFactory.userService().getCID();

        return "user_not_logged";
    }
}

export default TrackjsService;